<template>
  <div @click="onClick" :class="{ 'combo-disabled': !isSelectable }">
    <div
      class="combo-card"
      :style="{
        borderColor: checked ? prepayRateColor : '',
      }"
    >
      <div
        class="combo-name"
        :style="{
          backgroundColor: checked ? prepayRateColor : '',
          color: checked ? '#fff' : '',
        }"
      >
        方案{{ value.index }}
      </div>
      <div class="combo-title">
        <el-tooltip
          class="item"
          effect="dark"
          :content="`商品最高售价￥${value.maxLimitPrice}`"
          placement="top"
        >
          <i class="el-icon-info"></i>
        </el-tooltip>
        <div>{{ value.comboShowTitle }}</div>
        <div
          class="combo-title-check-box"
          :style="{
            borderColor: checked ? prepayRateColor : '',
            color: checked ? '#FFFFFF' : '',
            backgroundColor: checked ? prepayRateColor : '',
          }"
        >
          <i v-if="checked" class="el-icon-check"></i>
        </div>
      </div>

      <div class="combo-content">
        <div v-if="showRetailPrice" class="combo-item bold retail-price">
          <div class="combo-cell-right">零售价</div>
          <div class="combo-cell-left">￥{{ salePrice }}</div>
        </div>
        <div class="combo-item bold">
          <div class="combo-cell-right">首付金额</div>
          <div class="combo-cell-left">￥{{ value.prepayPrice }}</div>
        </div>
        <div class="combo-item bold">
          <div class="combo-cell-right">设备管理费</div>
          <div class="combo-cell-left">￥{{ value.lockPrice }}</div>
        </div>
      </div>

      <div
        class="combo-content"
        style="height: 280px; justify-content: flex-start"
      >
        <div class="combo-item bold">
          <div class="combo-cell-right">待还合计</div>
          <div class="combo-cell-left">￥{{ value.leftRentPrice }}</div>
        </div>
        <div
          class="combo-item"
          v-for="item in value.leftBillList"
          :key="item.billName"
        >
          <div class="combo-cell-right">{{ item.billName }}</div>
          <div class="combo-cell-left">￥{{ item.leftPayAmount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPrepayLevelByRate,
  PrepayLevelUnknownColor,
} from "@/enum/dict/index.js";

export default {
  name: "ComboCard",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    checked: {
      type: Boolean,
      default: false,
    },
    showRetailPrice: {
      type: Boolean,
      default: false,
    },
    salePrice: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    // 选中颜色跟随首付比档位，未知首付比使用中性灰。
    prepayRateColor() {
      return (
        getPrepayLevelByRate(this.value.prepayRate)?.color ||
        PrepayLevelUnknownColor
      );
    },
    /** 是否可选：selectable 为布尔值，true 可选，false 不可选，缺省默认可选 */
    isSelectable() {
      return this.value.selectable !== false;
    },
  },
  methods: {
    onClick() {
      if (!this.isSelectable) {
        return;
      }
      this.$emit("checkedChange");
    },
  },
};
</script>

<style lang="scss" scoped>
.combo-card {
  width: 260px;
  position: relative;
  border: 4px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  // overflow: hidden;
  padding: 8px;
  color: #000;
  background-color: #ffffff;
}

/* 不可选方案：置灰、不可点击，零售价字体改为红色 */
.combo-disabled {
  cursor: not-allowed;

  .combo-card {
    opacity: 0.55;
    cursor: not-allowed;

    .retail-price {
      opacity: 1;
      color: #f56c6c;
    }
  }
}

.combo-name {
  display: flex;
  align-items: center;
  position: absolute;
  background-color: #ffffff;
  top: 0;
  left: 0;
  font-weight: 600;
  padding: 6px 20px;
  font-size: 12px;
  transform: translateY(-80%);
  border-top-right-radius: 34px;
  border-bottom-right-radius: 34px;
  border-bottom-left-radius: 60px;
}

.combo-title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: #ffffff;
  padding: 8px 0;
  font-weight: bold;
  line-height: 24px;
  border-bottom: 1px solid #ddd;

  .combo-title-check-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    position: absolute;
    right: 8px;
    top: 10px;

    border: 2px solid #ddd;
    border-radius: 50%;

    color: #ddd;
  }
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ddd;
  gap: 8px;
  padding: 8px 0;

  .combo-name {
    max-width: 150px;
  }
}

.radio {
  margin-right: 0;
  /deep/ {
    .el-radio__label {
      display: none;
    }
  }
}

.large-combo-value {
  font-size: 16px;
  font-weight: bold;
}

.bold-combo-value {
  font-weight: bold;
}

.combo-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 8px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #ddd;
  }

  .combo-item {
    line-height: 24px;
    display: flex;
    justify-content: space-between;
    width: 100%;

    .combo-cell-right {
      padding: 0 15px;
      flex: 1;
      text-align: right;
    }

    .combo-cell-left {
      padding: 0 15px;
      flex: 1;
      text-align: left;
    }

    //& > div {
    //  padding: 0 15px;
    //  flex: 1;
    //  text-align: right;
    //}
  }

  .bold {
    font-weight: bold;
  }
}
</style>
